import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import { decodeToken } from "react-jwt";
import BaseListComponent, { BaseListComponentState, IFilterData } from "../../../../components/BaseListComponent";
import ItemsTable, { filterFieldData } from "../../../../components/tableComponents/itemsTable";
import { createFilterData, mapEntityList } from "../../../../services/utility/autoMapperService";
import TableFilterPane from "../../../../components/tableComponents/tableFilterPane";
import blackboxInstitutionService from "../../../../services/creditAssessment/blackboxInstitutionService";
import OcmInstitutionDetail from "./ocmInstitutionDetail";
import feeConfigService from "../../../../services/creditAssessment/feeConfigService";
import loanProductService from "../../../../services/creditAssessment/loanProductService";
import { retrieveAllByInstitutionId, retrieveAllByProductsByUseCase } from "../../../../services/auth/loanProductService";
import { toast } from "react-toastify";
import { getCurrentUserSession } from "../../../../services/auth/authService";
import EditOcmInstitution from "./editOcmInstitution";
import institutionConfigService from "../../../../services/creditAssessment/institutionConfigService";
import ModifyLoanPricingConfig from "./modifyLoanPricingConfig";

export interface OcmInstitutionsProps { }

export interface OcmInstitutionsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  allItems: any;
  feeConfig: any;
  allInstLoanProducts: any;
  ocmLoanProducts: any;
  authLoanProducts: any;
  institutionConfig: any;
  showPatchModal: boolean;
}

class OcmInstitutionsList extends BaseListComponent<OcmInstitutionsState> { }

class OcmInstitutions extends React.Component<
  OcmInstitutionsProps,
  OcmInstitutionsState
> {
  _isMounted = false;
  constructor(props: OcmInstitutionsProps) {
    super(props);
    this.state = {
      data: createFilterData([]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      feeConfig: {},
      allInstLoanProducts: [],
      ocmLoanProducts: [],
      authLoanProducts: [],
      institutionConfig: {},
      showPatchModal: false,
      allItems: [],
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    // const decodedToken = decodeToken(getCurrentUserSession().token || "");
    // let dataClone =
    //   typeof data === "undefined" ? { ...this.state.data } : { ...data };
    try {
      const insts = await blackboxInstitutionService.retrieveAllBlackboxInstitutions();
      //   console.log(insts.data)
      // dataClone["institutionId"] = {
      //   item1: "=",
      //   item2: decodedToken?.["InstitutionId"]?.toString() || "",
      // };
      // const OcmInstitutions = await OcmInstitutionService.filterPagedOcmInstitutions(
      //   dataClone,
      //   Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      //   currentPage
      // );
      const ocmInstitutions: any = [];
      const totalLength = insts.data.length;
      const initial = (currentPage - 1) * pageSize;
      for (let i = initial; i < initial + pageSize; i++) {
        if (i === totalLength) {
          break;
        }
        ocmInstitutions.push(insts.data[i]);
      }

      this.setState({
        tableItems: mapEntityList({
          // entityList: OcmInstitutions.data.item2,
          entityList: ocmInstitutions,
          properties: [
            { oldName: "institutionCode", newName: "institutionCode" },
            { oldName: "institutionName", newName: "institutionName" },
            { oldName: "ussdCode", newName: "ussdCode" },
            {
              isTag: true,
              oldName: "status",
              newName: "status",
              success: "Active",
              danger: "Inactive",
              default: "default",
              primary: "primary",
              secondary: "secondary",
              warning: "warning",
              light: "light",
              dark: "dark",
            },
            // { oldName: "dateCreated", newName: "dateCreated" },
            // { oldName: "dateUpdated", newName: "dateUpdated" },
          ],
        }),
        currentPage,
        pageSize,
        // totalSize: OcmInstitutions.data.item1,
        totalSize: totalLength,
        fetching: false,
        allItems: insts.data,
      });
    } catch (ex) {
      //   console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        this.setState({ fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        this.setState({ fetching: false });
      }
    }
  };

  handleOnExport = async (type: string) => { };

  fetchItemById = async (item: any) => {
    try {
      this.setState({ fetchingDetail: true });
      const decodedToken = decodeToken(getCurrentUserSession().token || "");

      const inst = await blackboxInstitutionService.retrieveBlackboxInstitutionById(item.id);

      const response = await Promise.all([
        feeConfigService.retrieveAllByInstitution(inst.data.institutionCode),
        retrieveAllByInstitutionId(inst.data.externalInstitutionId),
        retrieveAllByProductsByUseCase(inst.data.externalInstitutionId, "BlackBox"),
        loanProductService.retrieveAllByInstitutionCode(decodedToken?.["InstitutionCode"]),
        institutionConfigService.retrieveInstitutionConfig(inst.data.institutionCode)
      ])
      const fee = response[0];
      const allInstLoanProducts = response[1];
      const authLoanProducts = response[2];
      const ocmLoanProducts = response[3];
      const institutionConfig = response[4]; 
      // console.log(fee.data[0])
      this.setState({
        item: inst.data, feeConfig: fee.data[0],
        fetchingDetail: false, allInstLoanProducts: allInstLoanProducts.data,
        authLoanProducts: authLoanProducts.data, ocmLoanProducts: ocmLoanProducts.data,
        institutionConfig: institutionConfig.data
      });
    } catch (error) {
      toast.error("Something went wrong. Please, try again.");
      // console.log(error.response)
      this.setState({ fetchingDetail: false });
    }
  };

  onTogglePatchModal = () => {
    this.setState({
      showPatchModal: !this.state.showPatchModal,
      showDetailsModal: !this.state.showDetailsModal,
    });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      feeConfig,
      allInstLoanProducts,
      fetchingDetail,
      ocmLoanProducts,
      authLoanProducts,
      institutionConfig
    } = this.state;
    // console.log("asfsdf", this.state.filterValueInput);
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>View Institutions</b>
              </h3>
            </div>
            <OcmInstitutionsList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              //   updateState={this.state.updateBaseListState}
              initialValues={{
                data: createFilterData([]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
              }) => (
                <Fragment>
                  <OcmInstitutionDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    showTrail={null}
                    item={item}
                    feeConfig={feeConfig}
                    allInstLoanProducts={allInstLoanProducts}
                    blackBoxConfig={""}
                    institutionConfig={institutionConfig}
                    reloadDetails={() => this.fetchItemById(item)}
                    togglePatchModal={() => {
                      this.onTogglePatchModal();
                      onToggleDetailsModal();
                    }}
                  />
                  <EditOcmInstitution
                    showEditModal={showEditModal}
                    toggleEditModal={(reloadDetails: boolean, item: any) => {
                      onToggleEditModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                      this.setState({
                        showDetailsModal: !this.state.showDetailsModal,
                      });
                    }}
                    item={item}
                    feeConfig={feeConfig}
                    ocmLoanProducts={ocmLoanProducts}
                    authLoanProducts={authLoanProducts}
                  />
                  <ModifyLoanPricingConfig
                    showPatchModal={this.state.showPatchModal}
                    togglePatchModal={(reloadDetails: boolean, item: any) => {
                      this.onTogglePatchModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(this.state.item);
                      }
                      onToggleDetailsModal();
                    }}
                    item={institutionConfig}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Institutions"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                            //   timeColumn={["dateCreated","dateUpdated"]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></OcmInstitutionsList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default OcmInstitutions;
